export default __webpack_public_path__ + "static/logo-059a6676b733175817cd66a9a5467117.svg";